import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styles from './LandingPageSection2.module.css';
import image from '../../../../Images/newLandingPage/section2.png';

gsap.registerPlugin(ScrollTrigger);

const LandingPageSection2 = () => {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const featuresRef = useRef(null);
  const phoneRef = useRef(null);
  const circlesRef = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {

      // Title Animation - Line by line reveal
      gsap.from(titleRef.current.children, {
        y: 100,
        opacity: 0,
        duration: 1.2,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 70%",
          toggleActions: "play none none reverse"
        }
      });

      // Feature Cards - Staggered + Scrub Parallax
      gsap.utils.toArray(featuresRef.current.children).forEach((feature, i) => {
        if (feature.classList.contains(styles.divider)) return;

        gsap.from(feature, {
          y: 120,
          opacity: 0,
          duration: 1.4,
          ease: "power3.out",
          scrollTrigger: {
            trigger: feature,
            start: "top 85%",
            toggleActions: "play none none reverse"
          }
        });

        // Add subtle scrub float
        gsap.to(feature, {
          y: -30,
          ease: "none",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top bottom",
            end: "bottom top",
            scrub: 1.5,
          }
        });
      });

      // Phone Image - Parallax + 3D Tilt + Scale


      // Decorative Circles - Floating & Pulsing
      circlesRef.current.forEach((circle, i) => {
        gsap.to(circle, {
          y: -60 - (i * 30),
          x: i === 0 ? -40 : i === 1 ? 60 : -80,
          rotation: i % 2 === 0 ? 360 : -360,
          ease: "none",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top bottom",
            end: "bottom top",
            scrub: 2,
          }
        });

        // Pulsing scale animation
        gsap.to(circle, {
          scale: 1.3 + (i * 0.2),
          duration: 3 + i,
          repeat: -1,
          yoyo: true,
          ease: "sine.inOut"
        });
      });

    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className={styles.container} ref={sectionRef}>
      <div className={styles.content}>
        {/* <h2 className={styles.title} ref={titleRef}>
          <span>Transform Your Business Calls into</span>
          <span className={styles.highlight}>Growth Opportunities</span>
        </h2> */}
        <h2 className={styles.title} ref={titleRef}>
          Transform Your Business Calls into
          <span className={styles.highlight}> Growth Opportunities</span>
        </h2>

        <div className={styles.features} ref={featuresRef}>
          <div className={styles.feature}>
            <h3 className={styles.featureTitle}>24/7 Call Answering</h3>
            <p className={styles.featureDesc}>
              Never miss after-hours calls. AI handles inquiries even when your team is offline.
            </p>
          </div>
          <div className={styles.divider} />

          <div className={styles.feature}>
            <h3 className={styles.featureTitle}>Instant Lead Capture</h3>
            <p className={styles.featureDesc}>
              Automatically capture contact details and qualify leads during every call.
            </p>
          </div>
          <div className={styles.divider} />

          <div className={styles.feature}>
            <h3 className={styles.featureTitle}>Human-Like Conversations</h3>
            <p className={styles.featureDesc}>
              Customers can’t tell they’re talking to AI. Natural voice and intelligent responses.
            </p>
          </div>
          <div className={styles.divider} />

          <div className={styles.feature}>
            <h3 className={styles.featureTitle}>Automated Follow-Ups</h3>
            <p className={styles.featureDesc}>
              Send personalized SMS/email follow-ups immediately after each call.
            </p>
          </div>
        </div>
      </div>

      <div className={styles.imageContainer}>
        {/* <div className={styles.decorCircle1} ref={el => circlesRef.current[0] = el} />
        <div className={styles.decorCircle} ref={el => circlesRef.current[1] = el} />
        <div className={styles.decorCircle} ref={el => circlesRef.current[2] = el} /> */}

        <img
          ref={phoneRef}
          src={image}
          alt="AI Phone Assistant"
          className={styles.phone}
        />
      </div>
    </section>
  );
};

export default LandingPageSection2;